module.exports = __webpack_public_path__ + "img/cloud-upload.add61cda.svg";